module.exports = __webpack_public_path__ + "static/media/magda-ecommerce.c0855441.jpg";